import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api, { formatApiErrorDetail } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { isAccountant, isManager } from "@/lib/roles";
import { isSunday } from "@/lib/format";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Btn, Field } from "@/v2/ui";

// shifts are named by when they end: 8AM = 4pm the day before to 8am, 4PM = 8am to 4pm,
// Sunday has one shift (Saturday 4pm to Sunday 1pm)
export default function NewShiftButton() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const today = new Date().toISOString().slice(0, 10);
  const [open, setOpen] = useState(false);
  const [date, setDate] = useState(today);
  const [type, setType] = useState(new Date().getHours() < 12 ? "AM" : "PM");
  const [busy, setBusy] = useState(false);
  if (!isManager(user) && !isAccountant(user)) return null;
  const sunday = isSunday(date);
  const create = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/shifts", { date, shift_type: sunday ? "PM" : type, supervisor_name: "" });
      navigate(`/v2/shift/${data._id || data.id}`);
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };
  return (
    <>
      <Btn kind="primary" onClick={() => setOpen(true)}>New shift</Btn>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-sm">
          <DialogHeader><DialogTitle>New shift</DialogTitle></DialogHeader>
          <div className="grid gap-3">
            <Field label="Date"><input type="date" value={date} onChange={(e) => setDate(e.target.value)} className="min-h-[40px] rounded-md border border-slate-300 px-2 text-sm text-slate-800" /></Field>
            <Field label="Shift">
              <select value={sunday ? "PM" : type} disabled={sunday} onChange={(e) => setType(e.target.value)} className="min-h-[40px] rounded-md border border-slate-300 bg-white px-2 text-sm text-slate-800">
                {sunday ? <option value="PM">Sun 1PM (Sat 4pm – Sun 1pm)</option> : <>
                  <option value="AM">8AM (4pm the day before – 8am)</option>
                  <option value="PM">4PM (8am – 4pm)</option>
                </>}
              </select>
            </Field>
          </div>
          <DialogFooter><Btn onClick={() => setOpen(false)}>Cancel</Btn><Btn kind="primary" disabled={busy} onClick={create}>Create</Btn></DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
}
